import { render, staticRenderFns } from "./KeywordSearchIcon.vue?vue&type=template&id=6fd8c5b0&scoped=true"
import script from "./KeywordSearchIcon.vue?vue&type=script&lang=js"
export * from "./KeywordSearchIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd8c5b0",
  null
  
)

export default component.exports